import intl from 'react-intl-universal'
import Dialog from "material-ui/Dialog"
import PropTypes from 'prop-types'
import Button from 'components/button'

const Modal = ({ open, close, onClick }) => (
  <Dialog
    open={open}
    contentStyle={{ width: "600px" }}
  >
    <p className="mensagem-modal-confirmacao">{intl.get('orderPlanning.messageModalConfirmation')}</p>
    <p className="mensagem-modal-mensagem">{intl.get('orderPlanning.messageModalMessage')}</p>
    <div className="botoes-modal">
      <Button
        style={{width:"150px"}}
        value={intl.get('geral.modalConfirm.no')}
        onClick={close}
        className="btn"
      />
      <Button
        style={{width:"150px"}}
        buttonType="primary"
        value={intl.get('geral.modalConfirm.yes')}
        onClick={onClick}
        className="btn margin-botao"
      />
    </div>
  </Dialog>
)

Modal.propTypes = {
  open: PropTypes.bool,
  close: PropTypes.func,
  onClick: PropTypes.func
}

export default Modal
